"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _visuallyHiddenModule = _interopRequireDefault(require("../../../style/display/visually-hidden.module.scss"));
var _cachedBasket = require("../../../utils/basket/cachedBasket");
var _brands = require("../../../utils/brands/brands");
var _useEmailConfirmed = require("../../../utils/hooks/useEmailConfirmed");
var _useWindowSize2 = require("../../../utils/hooks/useWindowSize");
var _getProductUrl = _interopRequireDefault(require("../../../utils/product/getProductUrl"));
var _Checkbox = require("../../checkbox/Checkbox");
var _EnergyRating = require("../../energy-rating/EnergyRating");
var _Price = _interopRequireDefault(require("../../price/Price"));
var _SocialProofMessage = require("../../social-proof-message/SocialProofMessage");
var _AdditionalMessages = _interopRequireDefault(require("../additional-messages/AdditionalMessages"));
var _AgeVerification = require("../age-verification/AgeVerification");
var _CtaButton = require("../cta-button/CtaButton");
var _Image = _interopRequireDefault(require("../image/Image"));
var _PreOrder = _interopRequireDefault(require("../pre-order/PreOrder"));
var _PromoMessages = _interopRequireDefault(require("../promo-messages/PromoMessages"));
var _ProductCardRating = _interopRequireDefault(require("../rating/ProductCardRating"));
var _Sponsored = _interopRequireDefault(require("../sponsored/Sponsored"));
var _Swatches = _interopRequireDefault(require("../swatches/Swatches"));
var _Title = _interopRequireDefault(require("../title/Title"));
var _HeroAttributes = _interopRequireDefault(require("./hero-attributes/HeroAttributes"));
var _productCardDetailedModule = _interopRequireDefault(require("./product-card-detailed.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ALPHA__ProductCardDetailed = function ALPHA__ProductCardDetailed(_ref) {
  var _availability$futureA, _availability$preOrde, _energy$rating, _energy$rating2, _energy$rating3, _availability$futureA2, _availability$preOrde2;
  var product = _ref.product,
    _ref$hasAgeVerificati = _ref.hasAgeVerification,
    hasAgeVerification = _ref$hasAgeVerificati === void 0 ? false : _ref$hasAgeVerificati,
    _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
    hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
    _ref$hasDiorPromosEna = _ref.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref$hasDiorPromosEna === void 0 ? false : _ref$hasDiorPromosEna,
    _ref$hasEnergySideDra = _ref.hasEnergySideDrawer,
    hasEnergySideDrawer = _ref$hasEnergySideDra === void 0 ? false : _ref$hasEnergySideDra,
    _ref$hasHeroAttribute = _ref.hasHeroAttributes,
    hasHeroAttributes = _ref$hasHeroAttribute === void 0 ? false : _ref$hasHeroAttribute,
    _ref$hasLimitedSwatch = _ref.hasLimitedSwatches,
    hasLimitedSwatches = _ref$hasLimitedSwatch === void 0 ? false : _ref$hasLimitedSwatch,
    _ref$hasPromoMessageM = _ref.hasPromoMessageModal,
    hasPromoMessageModal = _ref$hasPromoMessageM === void 0 ? false : _ref$hasPromoMessageM,
    _ref$hasWishlistPlace = _ref.hasWishlistPlaceholder,
    hasWishlistPlaceholder = _ref$hasWishlistPlace === void 0 ? false : _ref$hasWishlistPlace,
    _ref$isPromoQuickView = _ref.isPromoQuickViewFlagOn,
    isPromoQuickViewFlagOn = _ref$isPromoQuickView === void 0 ? false : _ref$isPromoQuickView,
    _ref$hasSwatchTextBut = _ref.hasSwatchTextButNoRoundels,
    hasSwatchTextButNoRoundels = _ref$hasSwatchTextBut === void 0 ? false : _ref$hasSwatchTextBut,
    _ref$atbProps = _ref.atbProps,
    atbProps = _ref$atbProps === void 0 ? {} : _ref$atbProps,
    _ref$buttonSettings = _ref.buttonSettings,
    buttonSettings = _ref$buttonSettings === void 0 ? {} : _ref$buttonSettings,
    _ref$compareProps = _ref.compareProps,
    compareProps = _ref$compareProps === void 0 ? {} : _ref$compareProps,
    _ref$hasCompare = _ref.hasCompare,
    hasCompare = _ref$hasCompare === void 0 ? false : _ref$hasCompare,
    _ref$imageSettings = _ref.imageSettings,
    imageSettings = _ref$imageSettings === void 0 ? {} : _ref$imageSettings,
    _ref$monetateId = _ref.monetateId,
    monetateId = _ref$monetateId === void 0 ? '' : _ref$monetateId,
    _ref$moreInformationC = _ref.moreInformationCustomLabel,
    moreInformationCustomLabel = _ref$moreInformationC === void 0 ? '' : _ref$moreInformationC,
    _ref$pricePrefix = _ref.pricePrefix,
    pricePrefix = _ref$pricePrefix === void 0 ? '' : _ref$pricePrefix,
    _ref$selectedSwatch = _ref.selectedSwatch,
    selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
    _ref$socialProofMessa = _ref.socialProofMessage,
    socialProofMessage = _ref$socialProofMessa === void 0 ? null : _ref$socialProofMessa,
    _ref$socialProofMessa2 = _ref.socialProofMessageExperiments,
    socialProofMessageExperiments = _ref$socialProofMessa2 === void 0 ? [] : _ref$socialProofMessa2,
    _ref$sponsoredTitleEn = _ref.sponsoredTitleEnabled,
    sponsoredTitleEnabled = _ref$sponsoredTitleEn === void 0 ? false : _ref$sponsoredTitleEn,
    _ref$titleHeaderTagLe = _ref.titleHeaderTagLevel,
    titleHeaderTagLevel = _ref$titleHeaderTagLe === void 0 ? undefined : _ref$titleHeaderTagLe,
    _ref$handleClick = _ref.handleClick,
    handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
    _ref$handleDisplayPro = _ref.handleDisplayPromoModal,
    handleDisplayPromoModal = _ref$handleDisplayPro === void 0 ? undefined : _ref$handleDisplayPro,
    _ref$handleEnergyRati = _ref.handleEnergyRatingClick,
    handleEnergyRatingClick = _ref$handleEnergyRati === void 0 ? function () {} : _ref$handleEnergyRati,
    _ref$handleMoreInform = _ref.handleMoreInformationClick,
    handleMoreInformationClick = _ref$handleMoreInform === void 0 ? undefined : _ref$handleMoreInform,
    _ref$handleMoreSwatch = _ref.handleMoreSwatchesClick,
    handleMoreSwatchesClick = _ref$handleMoreSwatch === void 0 ? undefined : _ref$handleMoreSwatch,
    _ref$handleQuickAddCl = _ref.handleQuickAddClick,
    handleQuickAddClick = _ref$handleQuickAddCl === void 0 ? undefined : _ref$handleQuickAddCl,
    _ref$handleQuickViewC = _ref.handleQuickViewClick,
    handleQuickViewClick = _ref$handleQuickViewC === void 0 ? function () {} : _ref$handleQuickViewC,
    _ref$handleSwatchClic = _ref.handleSwatchClick,
    handleSwatchClickProp = _ref$handleSwatchClic === void 0 ? undefined : _ref$handleSwatchClic;
  var additionalMessages = product.additionalMessages,
    adId = product.adId,
    alternativeImageUrls = product.alternativeImageUrls,
    availability = product.availability,
    brand = product.brand,
    colorSwatches = product.colorSwatches,
    defaultSkuId = product.defaultSkuId,
    energy = product.energy,
    heroAttributes = product.heroAttributes,
    id = product.id,
    image = product.image,
    isMultiSku = product.isMultiSku,
    price = product.price,
    creditMessage = product.creditMessage,
    _product$promoMessage = product.promoMessages,
    promoMessages = _product$promoMessage === void 0 ? [] : _product$promoMessage,
    rating = product.rating,
    title = product.title,
    url = product.url;
  var hasEmailMeWhenAvailableButton = buttonSettings.hasEmailMeWhenAvailableButton,
    _buttonSettings$hasCt = buttonSettings.hasCtaButton,
    hasCtaButton = _buttonSettings$hasCt === void 0 ? true : _buttonSettings$hasCt;
  var emailConfirmed = (0, _useEmailConfirmed.useEmailConfirmed)(hasEmailMeWhenAvailableButton, id);
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMobileSize = _useWindowSize.isMobileSize;
  var cachedBasket = (0, _cachedBasket.useCachedBasketData)();
  var isAddedToBasket = cachedBasket.products.some(function (p) {
    return p.productId === id;
  });
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    swatchOverride = _useState2[0],
    setSwatchOverride = _useState2[1];
  var isAnyday = (0, _brands.isAnydayBrand)(brand);
  var productUrl = swatchOverride ? (0, _getProductUrl.default)(title, id, swatchOverride, adId) : url || (0, _getProductUrl.default)(title, id, selectedSwatch, adId);
  var getOverrideSwatch = function getOverrideSwatch(e) {
    var override = colorSwatches.find(function (_ref2) {
      var color = _ref2.color;
      return color === e.currentTarget.title || "".concat(color, " - Out of stock") === e.currentTarget.title;
    });
    return override;
  };
  var handleSwatchClick = function handleSwatchClick(e) {
    handleSelectedSwatchClick(e);
    if (handleSwatchClickProp) {
      handleSwatchClickProp(e);
    }
  };
  var handleSelectedSwatchClick = function handleSelectedSwatchClick(e) {
    e.preventDefault();
    var override = getOverrideSwatch(e);
    if (override) {
      setSwatchOverride(override);
    }
  };
  var handleEnergyArrowClick = function handleEnergyArrowClick(altText, rating) {
    handleEnergyRatingClick(altText, rating, energy === null || energy === void 0 ? void 0 : energy.label, energy === null || energy === void 0 ? void 0 : energy.informationSheet, adId, id);
  };
  var handlePromoMessagesClick = function handlePromoMessagesClick(_ref3) {
    var _ref3$shouldScrollToP = _ref3.shouldScrollToPromoMsgs,
      shouldScrollToPromoMsgs = _ref3$shouldScrollToP === void 0 ? false : _ref3$shouldScrollToP;
    var swatchOrder = (colorSwatches || []).map(function (_ref4) {
      var color = _ref4.color;
      return color;
    });
    return Promise.resolve(handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl.default)(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, shouldScrollToPromoMsgs, 'VIEW_OFFERS'));
  };
  var hasPreOrderMessages = (availability === null || availability === void 0 || (_availability$futureA = availability.futureAvailability) === null || _availability$futureA === void 0 ? void 0 : _availability$futureA.availableToOrderFromMessage) || (availability === null || availability === void 0 || (_availability$preOrde = availability.preOrder) === null || _availability$preOrde === void 0 ? void 0 : _availability$preOrde.streetDateMessage);
  var hasMessages = (promoMessages === null || promoMessages === void 0 ? void 0 : promoMessages.length) || (additionalMessages === null || additionalMessages === void 0 ? void 0 : additionalMessages.length) || hasPreOrderMessages || hasHeroAttributes && (heroAttributes === null || heroAttributes === void 0 ? void 0 : heroAttributes.length) || hasAgeVerification;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("article", {
    className: (0, _classnames.default)(_productCardDetailedModule.default['product-card']),
    "data-jlds": true,
    "data-product-id": id,
    "data-testid": "product-card",
    id: id,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)(_productCardDetailedModule.default['product-card-contents'], _defineProperty(_defineProperty(_defineProperty({}, _productCardDetailedModule.default['product-card-contents--has-messages'], hasMessages), _productCardDetailedModule.default['product-card-contents--has-wishlist'], hasWishlistPlaceholder), _productCardDetailedModule.default['product-card-contents--has-compare'], hasCompare)),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames.default)(_productCardDetailedModule.default.image),
        "data-testid": "product-image-container",
        children: [socialProofMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialProofMessage.SocialProofMessage, {
          message: socialProofMessage,
          monetateId: monetateId,
          socialProofMessageExperiments: socialProofMessageExperiments
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, _objectSpread({
          alternativeImageUrls: alternativeImageUrls,
          className: _productCardDetailedModule.default.image__image,
          handleClick: handleClick,
          hasAltImageOnHover: hasAltImageOnHover,
          image: image,
          multipleSwatches: colorSwatches && colorSwatches.length > 1,
          selectedSwatch: swatchOverride || selectedSwatch,
          title: title,
          url: productUrl
        }, imageSettings))]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _productCardDetailedModule.default.details,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _productCardDetailedModule.default['details__link-wrapper'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            className: _productCardDetailedModule.default.details__link,
            href: productUrl,
            onClick: handleClick,
            tabIndex: 0,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.default, {
              brand: isAnyday ? 'Anyday' : brand,
              brandPrefix: isAnyday ? 'John Lewis ' : '',
              headerTagLevel: titleHeaderTagLevel,
              isAnyday: isAnyday,
              isBranded: !!brand,
              isUnlimitedLines: true,
              title: title
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Sponsored.default, {
            hasSponsoredTitle: sponsoredTitleEnabled
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.default, {
            brand: brand,
            className: _productCardDetailedModule.default.details__price,
            creditMessage: creditMessage,
            dataTestIdPrefix: "product-card",
            hasDiorPromosEnabled: hasDiorPromosEnabled,
            isProductCardDetailed: true,
            price: price,
            pricePrefix: pricePrefix
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductCardRating.default, {
            className: _productCardDetailedModule.default.details__rating,
            rating: rating
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnergyRating.EnergyRating, {
          className: _productCardDetailedModule.default.energyRating,
          handleEnergyRatingClick: handleEnergyArrowClick,
          hasEnergySideDrawer: hasEnergySideDrawer,
          rating: energy !== null && energy !== void 0 && (_energy$rating = energy.rating) !== null && _energy$rating !== void 0 && _energy$rating.legacy ? undefined : energy === null || energy === void 0 || (_energy$rating2 = energy.rating) === null || _energy$rating2 === void 0 ? void 0 : _energy$rating2.value,
          ratingLegacy: energy !== null && energy !== void 0 && (_energy$rating3 = energy.rating) !== null && _energy$rating3 !== void 0 && _energy$rating3.legacy ? energy.rating.value : undefined
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Swatches.default, {
          baseUrl: productUrl,
          className: (0, _classnames.default)(_productCardDetailedModule.default.details__swatches),
          handleClick: handleSwatchClick,
          handleMoreSwatchesClick: handleMoreSwatchesClick,
          hasLimitedSwatches: hasLimitedSwatches,
          hasSwatchTextButNoRoundels: hasSwatchTextButNoRoundels,
          id: id,
          imageLoading: imageSettings.loading,
          selectedSwatch: swatchOverride || selectedSwatch,
          swatches: colorSwatches,
          title: title
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _productCardDetailedModule.default.messages,
        children: [hasHeroAttributes && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HeroAttributes.default, {
          heroAttributes: heroAttributes
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoMessages.default, {
          brand: brand,
          buttonClassName: (0, _classnames.default)(_productCardDetailedModule.default['messages__promo-button']),
          handleDisplayModal: handleDisplayPromoModal,
          handleQuickViewClick: handlePromoMessagesClick,
          hasDiorPromosEnabled: hasDiorPromosEnabled,
          hasPromoMessageModal: hasPromoMessageModal,
          isMobileSize: isMobileSize,
          isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
          productUrl: productUrl,
          promos: promoMessages,
          title: title,
          wrapperClassName: (0, _classnames.default)(_productCardDetailedModule.default.messages__promo)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreOrder.default, {
          availableToOrder: availability === null || availability === void 0 || (_availability$futureA2 = availability.futureAvailability) === null || _availability$futureA2 === void 0 ? void 0 : _availability$futureA2.availableToOrderFromMessage,
          className: (0, _classnames.default)(_productCardDetailedModule.default.messages__preorder),
          streetDate: availability === null || availability === void 0 || (_availability$preOrde2 = availability.preOrder) === null || _availability$preOrde2 === void 0 ? void 0 : _availability$preOrde2.streetDateMessage
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AgeVerification.AgeVerification, {
          className: _productCardDetailedModule.default['messages__age-verification'],
          hasAgeVerification: hasAgeVerification
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdditionalMessages.default, {
          messages: additionalMessages
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames.default)(_productCardDetailedModule.default.actions),
        children: [hasCtaButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CtaButton.CtaButton, _objectSpread(_objectSpread({}, buttonSettings), {}, {
          atbProps: atbProps,
          className: _productCardDetailedModule.default.actions__cta,
          emailConfirmed: emailConfirmed,
          handleMoreInformationClick: handleMoreInformationClick,
          handleQuickAddClick: handleQuickAddClick,
          handleQuickViewClick: handleQuickViewClick,
          hasShortCtaText: true,
          isAddedToBasket: isAddedToBasket,
          moreInformationCustomLabel: moreInformationCustomLabel,
          product: product,
          productUrl: productUrl,
          selectedSwatch: selectedSwatch,
          swatchOrder: (colorSwatches || []).map(function (_ref5) {
            var color = _ref5.color;
            return color;
          }),
          swatchOverride: swatchOverride
        })), hasWishlistPlaceholder && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _productCardDetailedModule.default.actions__wishlist,
          "data-product-id": id,
          "data-product-multi-sku": isMultiSku ? 'true' : 'false',
          "data-product-skuid": defaultSkuId,
          "data-wishlist-placeholder": true
        }), hasCompare && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.Checkbox, _objectSpread({
          className: _productCardDetailedModule.default.actions__compare,
          id: "compare-checkbox-".concat(id),
          isControlled: true
          // prettier-ignore
          ,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: ["Compare", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _visuallyHiddenModule.default.visuallyHidden,
              children: "Select for product comparison, ".concat(title)
            })]
          }),
          name: "compare-checkbox-".concat(id)
        }, compareProps))]
      })]
    })
  });
};
ALPHA__ProductCardDetailed.displayName = 'ProductCardDetailed';
var colorSwatchType = _propTypes.default.shape({
  color: _propTypes.default.string,
  colorSwatchUrl: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  isAvailable: _propTypes.default.bool,
  skuId: _propTypes.default.string,
  url: _propTypes.default.string
});
ALPHA__ProductCardDetailed.propTypes = {
  /** PRODUCT DATA */
  product: _propTypes.default.shape({
    /** Array of additional (non-promo) messages to display */
    additionalMessages: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Id of advert if product card is sponsored */
    adId: _propTypes.default.string,
    /** Indicates if a product is preorderable */
    availability: _propTypes.default.shape({
      futureAvailability: _propTypes.default.shape({
        availableToOrderFromMessage: _propTypes.default.string
      }),
      preOrder: _propTypes.default.shape({
        streetDateMessage: _propTypes.default.string
      })
    }),
    /** Brand */
    brand: _propTypes.default.string,
    /** Colour variants for product (if you want to show them) */
    colorSwatches: _propTypes.default.arrayOf(colorSwatchType),
    /** Energy rating info */
    energy: _propTypes.default.shape({
      rating: _propTypes.default.shape({
        legacy: _propTypes.default.bool,
        value: _propTypes.default.string
      }),
      label: _propTypes.default.string,
      informationSheet: _propTypes.default.string
    }),
    /** Hero attributes */
    heroAttributes: _propTypes.default.arrayOf(_propTypes.default.shape({
      key: _propTypes.default.string,
      displayName: _propTypes.default.string,
      values: _propTypes.default.arrayOf(_propTypes.default.string)
    })),
    /** Product ID */
    id: _propTypes.default.string.isRequired,
    /** Main/default product image */
    image: _propTypes.default.string.isRequired,
    /** Is this a multisku product */
    isMultiSku: _propTypes.default.bool,
    /** Is this a Product Card Detailed price */
    isProductCardDetailed: _propTypes.default.bool,
    /** Pricing object: { was, then1, then2, now } each a string or a range { from, to } */
    price: _propTypes.default.shape(_Price.default.propTypes),
    // Product Credit information */
    creditMessage: _propTypes.default.string,
    /** Array of promo messages to display */
    promoMessages: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Rating summary: { averageRating, reviews } */
    rating: _propTypes.default.shape(_ProductCardRating.default.propTypes),
    /** Default SkuId for the product */
    skuId: _propTypes.default.string,
    /** Optional property to render Social Proof Message */
    socialProofMessage: _propTypes.default.string,
    /** Product title */
    title: _propTypes.default.string.isRequired,
    /** Product (default) URL */
    url: _propTypes.default.string,
    /** default variantId for the product */
    variantId: _propTypes.default.string
  }).isRequired,
  /** FLAGS */
  /** Indicates detailed product card should show age verification message  */
  hasAgeVerification: _propTypes.default.bool,
  /** Indicate whether to try to display first alt image when main image hovered over */
  hasAltImageOnHover: _propTypes.default.bool,
  /** Indicate whether to apply Dior brand's styling rules */
  hasDiorPromosEnabled: _propTypes.default.bool,
  /** Enable energy side drawer when energy rating is clicked */
  hasEnergySideDrawer: _propTypes.default.bool,
  /** Enable display of hero attributes */
  hasHeroAttributes: _propTypes.default.bool,
  /** Indicates whether the list of swatches should have limited width */
  hasLimitedSwatches: _propTypes.default.bool,
  /** for experiment: Enable more promo messages to open in a dedicated modal */
  hasPromoMessageModal: _propTypes.default.bool,
  /** Indicates product card should have empty element ready for Wish List ESI to populate  */
  hasWishlistPlaceholder: _propTypes.default.bool,
  /** for experiment: Enable more promo messages to open in quick view */
  isPromoQuickViewFlagOn: _propTypes.default.bool,
  /** Indicates whether only total number of swatches should be shown */
  hasSwatchTextButNoRoundels: _propTypes.default.bool,
  /** OTHER SETTINGS */
  /** Add to basket button props */
  atbProps: _propTypes.default.shape({
    path: _propTypes.default.string,
    clientId: _propTypes.default.string.isRequired,
    onSuccess: _propTypes.default.func,
    onError: _propTypes.default.func,
    hasHeaderBasketCountEvent: _propTypes.default.bool,
    hasScreenReaderAnnouncement: _propTypes.default.bool
  }),
  buttonSettings: _propTypes.default.shape({
    /** Enable the email when available button */
    hasEmailMeWhenAvailableButton: _propTypes.default.bool,
    /** Enable the notify me button for future releases */
    hasNotifyMeButton: _propTypes.default.bool,
    /** Enable the add to basket button */
    hasAddToBasketButton: _propTypes.default.bool,
    /** Enable the More Information button for complex products */
    hasMoreInformationButton: _propTypes.default.bool,
    /** Enable Go to your basket button, if the SKU is in found in the cached_basket cookie */
    hasGoToBasketButton: _propTypes.default.bool,
    /** Enable We'll be in touch button */
    hasBeInTouchButton: _propTypes.default.bool,
    /** Enable Out of stock button */
    hasOosButton: _propTypes.default.bool
  }),
  /** Compare checkbox props */
  compareProps: _propTypes.default.shape({
    checked: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    onChange: _propTypes.default.func
  }),
  /** Indicates that the Compare feature is available for this product and localStorage can be used */
  hasCompare: _propTypes.default.bool,
  /** Image settings for sizing and loading */
  imageSettings: _propTypes.default.shape({
    /** Set the sizes attribute on the product image */
    sizes: _propTypes.default.string,
    /** Customize the set of widths for the product image srcSet attribute */
    srcSetWidths: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Set a custom aspect ratio for the image */
    aspectRatio: _propTypes.default.number,
    /** The image loading strategy to use */
    loading: _propTypes.default.oneOf(['eager', 'lazy'])
  }),
  /** Custom More Information label overwrite */
  moreInformationCustomLabel: _propTypes.default.string,
  /** Show additional pricing text */
  pricePrefix: _propTypes.default.string,
  /** Currently displayed variant: { skuId, color, url, colorSwatchUrl, imageUrl, isAvailable } */
  selectedSwatch: colorSwatchType,
  /** Indicates that product card should show Sponsored */
  sponsoredTitleEnabled: _propTypes.default.bool,
  /** Sets <H(1-6)> tag level for the title */
  titleHeaderTagLevel: _propTypes.default.number,
  /** HANDLERS */
  /** Custom event handler fired when clicking on any hyperlink within the card */
  handleClick: _propTypes.default.func,
  /** Custom event handler fired when displaying promo modal */
  handleDisplayPromoModal: _propTypes.default.func,
  /** Custom event handler fired when energy rating is clicked */
  handleEnergyRatingClick: _propTypes.default.func,
  /** Custom event handler fired when More information CTA button has been clicked */
  handleMoreInformationClick: _propTypes.default.func,
  /** Custom event handler fired when clicking on more colours available link within the card */
  handleMoreSwatchesClick: _propTypes.default.func,
  /** Custom event handler fired when quick add is opened */
  handleQuickAddClick: _propTypes.default.func,
  /** Custom event handler fired when quick view is opened (for view more promo messages) */
  handleQuickViewClick: _propTypes.default.func,
  /** Custom event handler fired when clicking on any swatch within the card */
  handleSwatchClick: _propTypes.default.func
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ALPHA__ProductCardDetailed);